// Manage a brand's question library outside of running an audit. Reuses
// the existing BrandQuestions component (previously deprecated alongside
// the old /llm surface) and gives it a dedicated route + nav entry from
// the brands hub.
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import AppShell from "../components/AppShell";
import BrandQuestions from "../components/BrandQuestions";
import { fetchBrandHub } from "../services/api";


export default function QuestionLibraryPage() {
  const navigate = useNavigate();
  const { brandId: brandIdParam } = useParams();
  const brandId = Number(brandIdParam);

  const [brand, setBrand] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshSignal, setRefreshSignal] = useState(0);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const items = await fetchBrandHub();
        const found = (items || []).find((b) => Number(b.id) === brandId) || null;
        if (!cancelled) setBrand(found);
      } catch {
        if (!cancelled) setBrand(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [brandId]);

  return (
    <AppShell>
      <div style={{ padding: "24px 32px", maxWidth: 1100, margin: "0 auto" }}>
        <div style={{ marginBottom: 18 }}>
          <button
            type="button"
            onClick={() => navigate("/brands-hub")}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              padding: "6px 14px",
              fontSize: 13,
              fontWeight: 600,
              color: "#1a1f36",
              background: "#ffffff",
              border: "1px solid #d1d5db",
              borderRadius: 8,
              cursor: "pointer",
              marginBottom: 14,
              boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
              transition: "all 0.15s",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = "#f9fafb"; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = "#ffffff"; }}
          >
            <span aria-hidden>←</span>
            Brands hub
          </button>
          <h1 style={{ margin: 0, fontSize: 24, fontWeight: 800 }}>
            Question library
            {brand?.name && (
              <span style={{ color: "#6b7280", fontWeight: 600, marginLeft: 10 }}>
                · {brand.name}
              </span>
            )}
          </h1>
          <p style={{ marginTop: 4, color: "#6b7280", fontSize: 13, maxWidth: 720 }}>
            Edit the brand's saved question pool. Changes here become the default question
            set for new analysis runs. Mid-run edits still happen inside the wizard's
            Stage 1 — those are scoped to the run and do not touch this library unless you
            explicitly save them back.
          </p>
        </div>

        {loading ? (
          <div style={{ color: "#6b7280", padding: 20 }}>Loading…</div>
        ) : !brand ? (
          <div
            style={{
              padding: 20,
              borderRadius: 12,
              border: "1px solid #fecaca",
              background: "#fef2f2",
              color: "#991b1b",
            }}
          >
            Brand not found, or you do not have access to it.
          </div>
        ) : (
          <BrandQuestions
            brandId={brandId}
            refreshSignal={refreshSignal}
            onChange={() => setRefreshSignal((v) => v + 1)}
          />
        )}
      </div>
    </AppShell>
  );
}
